import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocale } from '../hooks/useLocale.jsx';
import { StyleGallery } from '../components/StyleGallery.jsx';
import { GalleryBriefs } from '../components/GalleryBriefs.jsx';
import { AIService, SPACE_CATEGORIES } from '../services/ai-service.js';
import { fetchStyleStats } from '../services/style-stats-service.js';
import { useSeasonConfig } from '../services/season-config.js';
import { logEvent, analytics } from '../firebase.js';

// /gallery — 갤러리 탭 (2.3.0). 만들기 화면 안의 "지금 뜨는 스타일" 오버레이를
// 탭으로 꺼낸 것. 본문은 StyleGallery 그대로이고, 여기서 고르면 그 스타일이
// 미리 골라진 채로 /create 로 넘어간다 (HomePage 가 location.state 를 prefill 로
// 읽는다 — "이 스타일로 만들기" 와 같은 경로).
const CATEGORY_KEY = 'voda_gallery_category';

export function Gallery({ onCreditsClick }) {
  const { t } = useLocale();
  const navigate = useNavigate();
  useSeasonConfig();

  const [category, setCategory] = useState(() => {
    try {
      const saved = localStorage.getItem(CATEGORY_KEY);
      return SPACE_CATEGORIES.includes(saved) ? saved : 'interior';
    } catch { return 'interior'; }
  });
  const pickCategory = (cat) => {
    setCategory(cat);
    try { localStorage.setItem(CATEGORY_KEY, cat); } catch { /* ignore */ }
  };

  const [stats, setStats] = useState(null);
  useEffect(() => {
    let stale = false;
    fetchStyleStats().then((d) => { if (!stale) setStats(d); });
    return () => { stale = true; };
  }, []);

  const styleKeys = Object.keys(AIService.styleCatalog(category));

  const pickBuiltin = (key) => {
    logEvent(analytics, 'gallery_style_picked', { kind: 'builtin', style: key, spaceCategory: category });
    navigate('/create', { state: { spaceCategory: category, style: key, fromGallery: true } });
  };
  const pickCustom = (prompt) => {
    logEvent(analytics, 'gallery_style_picked', { kind: 'custom', spaceCategory: category });
    navigate('/create', { state: { spaceCategory: category, style: 'custom', customStyle: prompt, fromGallery: true } });
  };

  return (
    <StyleGallery
      asPage
      stats={stats}
      styleKeys={styleKeys}
      spaceCategory={category}
      onPickBuiltin={pickBuiltin}
      onPickCustom={pickCustom}
      headerExtra={(
        <>
        <GalleryBriefs category={category} onCreditsClick={onCreditsClick} />
        <div className="space-category-toggle gallery-category-toggle">
          {SPACE_CATEGORIES.map((cat) => (
            <button
              key={cat}
              type="button"
              className={`space-category-btn ${category === cat ? 'active' : ''}`}
              aria-pressed={category === cat}
              onClick={() => pickCategory(cat)}
            >
              {t('spaceCategories.' + cat)}
            </button>
          ))}
        </div>
        </>
      )}
    />
  );
}
